import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_spreadsheet_sheet = _resolveComponent("spreadsheet-sheet")!
  const _component_spreadsheet = _resolveComponent("spreadsheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.formLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_GridLoading)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_spreadsheet, { ref: "spreadsheet" }, {
        default: _withCtx(() => [
          _createVNode(_component_spreadsheet_sheet, {
            name: 'Style Upload Sheet',
            rows: _ctx.jsondata,
            columns: _ctx.columns
          }, null, 8, ["rows", "columns"])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}